// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import NoAvatar from '../../../NoAvatar.jpg';

const StyledAvatar = styled.td`
  width: 10%;
  min-width: 60px;
  &&& {
    border-top: none;
  }
  img {
    width: 50px;
    height: 50px;
  }
`;

const StyledName = styled.td`
  width: 90%;
  &&& {
    border-top: none;
  }
`;

const StyledDeleteIcon = styled.td`
  width: 5%;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  &&& {
    border-top: none;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const AmbassadorElement = ({ value, ind, notHeader, actions }) => {
  const deleteExperience = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.deleteExperience(event.currentTarget.dataset.name, 'ambassador');
  };

  const topBorder = notHeader && ind === 0 ? 'none' : '1px solid #ddd';
  return (
    <tr
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      key={value.id}
      data-name={ind}
      className='listrow moveable'
      style={{ borderTop: topBorder }}
    >
      <StyledAvatar>
        <img
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          src={value.photo || NoAvatar}
          alt='...'
          className='img-thumbnail'
        />
      </StyledAvatar>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      <StyledName>{value.name}</StyledName>
      <StyledDeleteIcon>
        <i
          className='fas fa-times'
          data-name={ind}
          onClick={deleteExperience}
        />
      </StyledDeleteIcon>
    </tr>
  );
};

export default React.memo(AmbassadorElement);
